<template>
    <v-card>
      <v-card-title class="dialog-header">
        <span class="headline">{{ $t("addCategory") }}</span>
        <v-spacer></v-spacer>
        <v-btn
          fab
          text
          icon
          @click="handleClose()"
          valid="false"
          v-shortkey="['esc']"
          @shortkey.native="handleClose()"
        >
        <span class="white--text">
          <v-icon dark>
            mdi-close
          </v-icon>
        </span>
        </v-btn>
      
        </v-card-title>
          <v-card-text>
            <v-form v-model="valid" ref="formCategory">
                  <v-container>
                    <v-row :no-gutters="$vuetify.breakpoint.mobile">

                        <v-col cols="8">
                          <v-text-field
                            v-model="formDoc.name"
                            :label="$t('categoryName') + '*'"
                            :rules="valueRules"
                            required
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>

                         <v-col cols="8">
                          <v-text-field
                            v-model="formDoc.short_code"
                            :label="$t('code') + '*'"
                            :rules="valueRules"
                            required
                            outlined
                            
                            dense
                          ></v-text-field>
                        </v-col>

                         <v-col cols="8">
                            <v-autocomplete
                              v-model="formDoc.product_type"
                              :items="parentCategories"
                              item-name="product_type"
                              item-value="product_type"
                              outlined
                              :dense="dense"
                              :label="$t('type') + '*'"
                              clearable
                              :rules="valueRules"
                              required
                            >
                              <template v-slot:item="{item}">{{$t(item.product_type)}}</template>
                              <template v-slot:selection="{item}">{{$t(item.product_type)}}</template>
                            </v-autocomplete>
                        </v-col>

                        <!-- <v-col cols="8">
                            <v-checkbox
                              v-model="formDoc.addAsSubCategory"
                              :label="$t('addAsSubCategory')"
                              style="margin-top: -10px !important"
                            ></v-checkbox>
                        </v-col>

                         <v-col cols="8" v-if="formDoc.addAsSubCategory">
                            <v-autocomplete
                              v-model="formDoc.parentCategory"
                              :items="childCategories"
                              item-text="name"
                              item-value="id"
                              outlined
                              :dense="dense"
                              auto-select-first
                              :label="$t('parentCategory')"
                              clearable
                            >
                            </v-autocomplete>
                        </v-col> -->

                        <v-col cols="8">
                          <div style="text-align: right">

                              <v-btn color="default" outlined text @click="handleClose()">
                                  {{ $t('close') }}
                              </v-btn>
                              <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
                                  <font-awesome-icon icon="check-circle" class="mr-1"/>
                                  {{ $t('save') }}
                              </v-btn>         
                          </div>
                        </v-col>
                    </v-row>


                  </v-container>
                </v-form>
          </v-card-text>
    </v-card>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";

export default {
  name: "category",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      formDoc: {
        id: "",
        short_code: "",
        name: "",
        product_type: "",
        parent_id: "",
        // addAsSubCategory: false,
        // parentCategory: "",
        contact_id: this.$store.state.userDoc.contact_id,
        eco_business: 'out_side',
      },

    };
  },

  mounted() {
    if(this.$store.state.outsideBusiness.dialog && this.$store.state.outsideBusiness.dialog_type == 'category'){
      this.fetchParentCategory();
    }
  },

  methods: {
    reset() {
      let vm = this;
      if (vm.$refs.formCategory) {
        vm.$refs.formCategory.resetValidation();
          vm.formDoc.id           = "";
          vm.formDoc.short_code   = "";
          vm.formDoc.name         = "";
          vm.formDoc.product_type  = "";
          // vm.formDoc.addAsSubCategory = false;
          // vm.formDoc.parentCategory= "";
      }
      this.$store.dispatch('updateOutsideBusinessProduct', {});

    },

    async handleClose(){
        await this.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'product'})
        this.reset();
    },

    async submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formCategory.validate()) {
          vm.overlay = true;

          let url = provider.baseURL + provider.storeCategory;

          return new Promise((resolve, reject) => {
              axios.post(url, this.formDoc, {headers: {
                Authorization: localStorage.token,
                "Content-Type": "multipart/form-data"
                }}).then(
                  res => {
                      if (res.data.response && res.data.response.code === 200) {
                          vm.$notify({
                              title: "Success",
                              message: vm.$t("success"),
                              type: "success",
                              duration: 700
                          });

                          this.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'product'});
                          this.$nextTick(() => {
                            vm.reset();
                          })
                      }
                  },
                  error => {
                      reject(error);
                  }
              );
          });
      }
    }
  },

  computed:{},
  watch: {

    // "formDoc.addAsSubCategory"(val){
    //   if(! val) { this.formDoc.parentCategory = ''; }
    // },
    // "formDoc.product_type"(val){
    //   if(val){
    //     this.fetchChildCategory({product_type: val})
    //   }
    // },
    
   
  }
  
};
</script>